import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './InspectionType.module.scss';
import { useSelector, useDispatch } from 'react-redux';
import { getInspectionType } from '../../selectors/index';
import { FormattedMessage, injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { initialInspectionTypeState } from '../../store/reducers/initialState';
import uuidv4 from 'uuid/v4';
import { useParams, Redirect, useHistory } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GoBack from '../WSAControls/GoBack/GoBack';
import classNames from 'classnames';
import { isRequired } from '../../utils';
import Cookies from 'js-cookie';
import OperationalSetupContentTemplate from '../OperationalSetup/OperationalSetupContentTemplate';
import InspectionTypeQuestionList from '../InspectionTypeQuestion/InspectionTypeQuestionList';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import {
  describeInspectionTypeThunk,
  saveInspectionTypeThunk,
  setInspectionTypeChangeThunk,
  setInspectionTypeCleanUpThunk
} from '../../store/actions/inspectionType';
// import { describeInspectionTypeQuestionThunk } from '../../store/actions/inspectionTypeQuestion';
import uuid from 'uuid';
const envName = process.env.REACT_APP_ENV_NAME_SHORT;

const InspectionType = ({ intl }) => {
  let history = useHistory();
  let { inspectionTypeId } = useParams();

  const dispatch = useDispatch();
  const inspectionType = useSelector(state => getInspectionType(state));
  const userProfileWidgets = useSelector(state => state.userProfileWidgets);

  let IsEdit = false;

  const [localformErrors, setFormErrors] = useState({});

  const backUrl = '/operational-setup/inspection-report';
  let widgetCode = '';
  if (inspectionTypeId) {
    IsEdit = true;
    widgetCode = 'WQSP_INSPECTIONTYPE_EDIT';
  }

  useEffect(() => {
    if (inspectionTypeId) {
      dispatch(describeInspectionTypeThunk(inspectionTypeId, widgetCode));
    }
  }, [describeInspectionTypeThunk, dispatch, inspectionTypeId]);

  // useEffect(() => {
  //   if (inspectionTypeId) {
  //     dispatch(describeInspectionTypeQuestionThunk(null, 'WQSP_INSPECTIONTYPEQUESTION_LIST', inspectionTypeId));
  //   }
  // }, [describeInspectionTypeQuestionThunk, dispatch, inspectionTypeId]);

  //clean up
  useEffect(() => {
    return () => {
      dispatch(setInspectionTypeCleanUpThunk(initialInspectionTypeState.inspectionType.SelectedInspectionType));
    };
  }, []);

  // Update redux store
  const setLocalInspectionType = currentState => {
    dispatch(setInspectionTypeChangeThunk(currentState));
  };

  //Saving
  const submitForm = e => {
    e.preventDefault();

    if (!validateInput()) {
      return;
    }

    let saveData = inspectionType.SelectedInspectionType;
    saveData.PerformDelete = false;
    saveData.IsEdit = IsEdit;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;

    if (!IsEdit) {
      saveData.InspectionTypeId = 0;
      saveData.GuidIdentifier = uuidv4();
      widgetCode = 'WQSP_INSPECTIONTYPE_ADDNEW';
    }

    dispatch(saveInspectionTypeThunk(saveData, widgetCode));
  };

  const validateInput = () => {
    let formErrors = {};
    let isValid = true;

    if (
      !inspectionType ||
      !inspectionType.SelectedInspectionType ||
      !inspectionType.SelectedInspectionType.Name ||
      isRequired(inspectionType.SelectedInspectionType.Name, 1)
    ) {
      formErrors.Name = intl.formatMessage({
        id: 'common.titleRequired',
        defaultMessage: 'Title is a mandatory field'
      });
      isValid = false;
    }
    if (
      !inspectionType ||
      !inspectionType.SelectedInspectionType ||
      !inspectionType.SelectedInspectionType.GeneralInformation ||
      isRequired(inspectionType.SelectedInspectionType.GeneralInformation, 1)
    ) {
      formErrors.GeneralInformation = intl.formatMessage({
        id: 'inspectionTypes.generalInformationRequired',
        defaultMessage: 'General information is a mandatory field'
      });
      isValid = false;
    }

    setFormErrors(formErrors);

    return isValid;
  };

  //on control value change
  const onChange = e => {
    setLocalInspectionType({
      ...inspectionType,
      SelectedInspectionType: { ...inspectionType.SelectedInspectionType, [e.target.name]: e.target.value }
    });
  };

  const cancelHandler = () => {
    history.push(backUrl);
  };

  let messageId = (inspectionType && inspectionType.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const modelCompTypeName = (inspectionType.SelectedInspectionType ? inspectionType.SelectedInspectionType.Name : '') || '';
  let heading = '';
  if (IsEdit) {
    heading = intl.formatMessage({ id: 'common.edit', defaultMessage: 'Edit' }) + ' ' + modelCompTypeName;
  } else {
    heading = intl.formatMessage({ id: 'inspectionTypes.addInspectionType', defaultMessage: 'Add new inspection purpose' });
  }

  return (
    <div className={s.inspectionType}>
      {inspectionType.isLoading && <LoadingSpinner />}
      {inspectionType.isRedirect ? <Redirect to={backUrl} /> : ''}
      <Banner
        key={uuid()}
        failureText={messageText}
        showBanner={inspectionType.showBanner}
        status={inspectionType.isOpSuccessful}
        successText={messageText}
      />
      <OperationalSetupContentTemplate selectedPage="inspectionReport" userProfileWidgets={userProfileWidgets}>
        <div className={s.contentWrapper}>
          <div className={s.inspectionTypeHeader}>
            <GoBack className={s.backLink}>
              &lt; &nbsp;
              <FormattedMessage id="common.back" defaultMessage="BACK" />
            </GoBack>
            <h3>{heading}</h3>
          </div>
          <div className={s.inspectionTypeContent}>
            <Form>
              <div className={s.topRow}>
                <Row>
                  <Col lg={4}>
                    <Form.Group controlId="formInspectionTypeName">
                      <Form.Label>
                        <FormattedMessage id="common.title" defaultMessage="Title" />
                      </Form.Label>

                      <Form.Control
                        type="text"
                        name="Name"
                        onChange={onChange}
                        value={inspectionType.SelectedInspectionType.Name}
                        className={`${s.formControl} ${localformErrors && localformErrors.Name ? s.formControlError : ''}`}
                        placeholder={intl.formatMessage({
                          id: 'common.title',
                          defaultMessage: 'Title'
                        })}
                      />
                      {localformErrors && localformErrors.Name && (
                        <p role="alert" className={s.error}>
                          {localformErrors.Name}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group controlId="formInspectionTypeGeneralInformation">
                      <Form.Label>
                        <FormattedMessage id="inspectionTypes.generalInformation" defaultMessage="General Information" />
                      </Form.Label>

                      <Form.Control
                        className={`${s.textArea} ${localformErrors && localformErrors.Name ? s.formControlError : ''}`}
                        as="textarea"
                        rows="3"
                        name="GeneralInformation"
                        onChange={onChange}
                        placeholder={intl.formatMessage({
                          id: 'inspectionTypes.generalInformation',
                          defaultMessage: 'General Information'
                        })}
                        value={inspectionType.SelectedInspectionType.GeneralInformation}
                      />
                      {localformErrors && localformErrors.GeneralInformation && (
                        <p role="alert" className={s.error}>
                          {localformErrors.GeneralInformation}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group controlId="formInspectionTypeDescription">
                      <Form.Label>
                        <FormattedMessage id="common.description" defaultMessage="Description" />
                      </Form.Label>

                      <Form.Control
                        className={s.textArea}
                        as="textarea"
                        rows="3"
                        name="Description"
                        onChange={onChange}
                        placeholder={intl.formatMessage({
                          id: 'common.description',
                          defaultMessage: 'Description'
                        })}
                        value={inspectionType.SelectedInspectionType.Description}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      variant="primary"
                      className={classNames(s.margin5, s.btnSaveChanges)}
                      onClick={submitForm}
                      noValidate
                      data-unittest="saveData"
                    >
                      <FormattedMessage id="common.save" defaultMessage="SAVE" />
                    </Button>

                    <Button
                      variant="outline-secondary"
                      className={classNames(s.btnCancel)}
                      onClick={cancelHandler}
                      noValidate
                      data-unittest="saveCancel"
                    >
                      <FormattedMessage id="common.cancel" defaultMessage="CANCEL" />
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
          </div>
          {inspectionTypeId && (
            <InspectionTypeQuestionList
              userProfileWidgets={userProfileWidgets}
              inspectionTypeSpecificQuestions={true}
              inspectionSurveyTypeId={inspectionTypeId}
            />
          )}
        </div>
      </OperationalSetupContentTemplate>
    </div>
  );
};

InspectionType.defaultProps = {
  inspectionType: {
    ...initialInspectionTypeState
  }
};

export default injectIntl(InspectionType);
